import { Injectable } from '@angular/core';

@Injectable()
export class ImageService {

  public encodeB64(imageBin: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(imageBin);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

}
